import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import { testUser } from 'Util/stubs/testUser.stub.ts'

export const useGetAuthenticatedUser = () => {
  return useSelector(getAuthenticatedUser)
}

export const getAuthenticatedUser = (state: typeof State) => {
  return Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT !== 'production' ? testUser : state[authenticationSlice.name].user
}
